export default __webpack_public_path__ + "static/media/django-icon.f432cc60.png";